import { render, staticRenderFns } from "./marketAnalysis.vue?vue&type=template&id=187f3cc7&scoped=true"
import script from "./marketAnalysis.vue?vue&type=script&lang=js"
export * from "./marketAnalysis.vue?vue&type=script&lang=js"
import style0 from "./marketAnalysis.vue?vue&type=style&index=0&id=187f3cc7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187f3cc7",
  null
  
)

export default component.exports